import { Component } from '@angular/core';
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-cadastro-imed',
    templateUrl: './cadastro-imed.component.html',
    styleUrl: './cadastro-imed.component.css',
    standalone: false
})
export class CadastroImedComponent {
  constructor(private titleService: Title) {
    this.titleService.setTitle('IMed - Gestão de Pacientes');
    this.setFavicon('faviconImed.ico');
  }

  setFavicon(faviconUrl: string): void {
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
